export default __webpack_public_path__ + "static/media/vada pav.png.688d25eb.png";